import * as React from "react";
import PropTypes from "prop-types";
import prefixStyles from "../utils/prefixStyles";
import { IconChevronRight } from "../Icons";
import Tappable from "../Tappable";

const styles = prefixStyles({
  labelContainer: {
    display: "flex",
  },
  label: {
    flex: "1 1 auto",
  },
  iconContainer: {
    flex: "0 0 auto",
    width: "1.5em",
  },
  icon: {
    transition: "all 100ms ease-in-out",
  },
  iconOpen: {
    transform: "rotate(90deg)",
  },
  children: {
    paddingLeft: "2.5em",
    overflow: "hidden",
    height: 0,
  },
  childrenOpen: {
    height: "inherit",
  },
});

export default class CollapsableList extends React.Component {
  static propTypes = {
    open: PropTypes.bool,
    header: PropTypes.node,
    items: PropTypes.node,
  };

  state = {
    open: this.props.open,
  };

  _handleTap = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  render() {
    const { open } = this.state;
    const { header, items } = this.props;

    return (
      <div data-component-name="CollapsibleList">
        <div style={styles.labelContainer}>
          <Tappable onTap={this._handleTap}>
            {({ tapTargetRefHandler }) => (
              <span style={styles.iconContainer} ref={tapTargetRefHandler}>
                {header ? (
                  <IconChevronRight
                    style={{
                      ...styles.icon,
                      ...(open ? styles.iconOpen : null),
                    }}
                  />
                ) : null}
              </span>
            )}
          </Tappable>
          <div data-name={"header"} style={styles.label}>
            {header || items}
          </div>
        </div>
        {header && items ? (
          <div
            data-name={"items"}
            style={{
              ...styles.children,
              ...(open ? styles.childrenOpen : null),
            }}
          >
            {items}
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Pivot/CollapsibleList.jsx